import { render, staticRenderFns } from "./SideStockInfo.vue?vue&type=template&id=398bf78a&scoped=true"
import script from "./SideStockInfo.vue?vue&type=script&lang=js"
export * from "./SideStockInfo.vue?vue&type=script&lang=js"
import style0 from "./SideStockInfo.vue?vue&type=style&index=0&id=398bf78a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398bf78a",
  null
  
)

export default component.exports